import React, { useState, useMemo, useCallback } from "react"
import MainContent from "./MainContent"
import UpgradeModal from "./modals/UpgradeModal"
import DowngradeModal from "./modals/DowngradeModal"
import CancelModal from "./modals/CancelModal"
import AddPaymentModal from "./modals/AddPaymentModal"
import DeletePaymentModal from "./modals/DeletePaymentModal"
import PackageSummaryModal from "../Razorpay/PackageSummaryModal"
import RazorpayModal from "../Razorpay/RazorpayModal"
import { useRazorpay } from "../../../../context/RazorpayContext"
import Breadcrumb from "../../../../utility/breadcrumb/Breadcrumb"
import { useBilling } from "../../../../context/BillingContext"


const BillingDashboard = () => {
  const {
    invoiceModalData,
    razorpayModalData,
  } = useRazorpay();
  const {refetchBilling} = useBilling();
  const [activeModal, setActiveModal] = useState(null)
  const [modalData, setModalData] = useState(null)
  const afterPaymentSuccessNavigationUrl = '/billing-section';

  const openModal = useCallback((modalName, data = null) => {
    setActiveModal(modalName)
    setModalData(data)
  }, [])

  const closeModal = useCallback(() => {
    setActiveModal(null)
    setModalData(null)
  }, [])

  const modals = useMemo(
    () => ({
      upgrade: UpgradeModal,
      downgrade: DowngradeModal,
      cancel: CancelModal,
      addPayment: AddPaymentModal,
      deletePayment: DeletePaymentModal,
    }),
    []
  )

  const ActiveModal = activeModal ? modals[activeModal] : null

  return (<>

    {razorpayModalData?.isRazorPayModal && (
      <RazorpayModal
        navigationUrl={afterPaymentSuccessNavigationUrl}
      />
    )}
    <div className='without-datepicker-breadcrumb'>
      <Breadcrumb />
    </div>
    <div className="d-flex px-2 p-sm-0">
      <MainContent openModal={openModal} />
    </div>
    {ActiveModal && (
      <ActiveModal openModal={openModal} show data={modalData} onClose={closeModal} />
    )}
  </>

  )
}

export default BillingDashboard
